module.exports = __webpack_public_path__ + "images/star_unfill900087eaba0640e92f1559d28f1877e9.png";